// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"gamepad-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 7H21V19H3V7Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 7V4C12 3.44772 12.4477 3 13 3H16M3 7V19H21V7H3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M6 13H8M8 13H10M8 13V11M8 13V15M14 13H14.0035V13.004H14V13ZM16 11H16.0035V11.004H16V11ZM16 15H16.0035V15.004H16V15ZM18 13H18.0035V13.004H18V13Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Gamepad1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'gamepad-1',
    ref,
    icon: element,
  },
));

Gamepad1Icon.displayName = 'Gamepad1Icon';

export default Gamepad1Icon;
